import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import Breadcrumb from '../../components/breadcrumbs/Breadcrumb';

import UpsellsTable from '../../components/upsells/UpsellsTable';

function Upsells() {

  return (
    <div className="uk-container">

      <div data-uk-grid>

        <div className="uk-width-3-4">
          <Breadcrumbs>
            <Breadcrumb><NavLink to="/">Панель администратора</NavLink></Breadcrumb>
            <Breadcrumb><span>Товары допродаж</span></Breadcrumb>
          </Breadcrumbs>
        </div>

      </div>

      <h1 className="uk-heading-line uk-text-center">
        <span>Товары допродаж</span>
      </h1>

      <h1 className="uk-heading-divider"></h1>

      <UpsellsTable />

    </div>
  )
}

export default Upsells;
